import type { TAmountParam } from '~/interfaces/TAmountParam';

export const getAmountParamBySplitterId = (splitterId: string): TAmountParam => {
  switch (splitterId.toLowerCase()) {
    case 'wp-mortgage':
      return 'PurchasePrice';
    default:
      return 'Amount';
  }
};
